import { OccupationAccreditation } from '../../accreditation/occupation';

export class Speciality {
    id: number;
    name: string;
    description: string;
    jurisprudence: string;
    occupation: OccupationAccreditation;
}